import { Link, useLocation } from 'react-router-dom';
import { LayoutDashboard, Building2, Calculator, Settings } from 'lucide-react';
import { cn } from '@/lib/utils';

const navigation = [
  { name: 'Home', href: '/', icon: LayoutDashboard },
  { name: 'Objekte', href: '/properties', icon: Building2 },
  { name: 'Rechner', href: '/calculator', icon: Calculator },
  { name: 'Mehr', href: '/settings', icon: Settings },
];

export function BottomNav() {
  const location = useLocation();

  return (
    <nav className="md:hidden fixed bottom-0 left-0 right-0 z-50 bg-background/90 backdrop-blur-lg border-t border-border"
      style={{ paddingBottom: 'env(safe-area-inset-bottom)' }}
    >
      <div className="flex items-center justify-around h-16">
        {navigation.map((item) => {
          const isActive = item.href === '/'
            ? location.pathname === '/'
            : location.pathname.startsWith(item.href);
          const Icon = item.icon;
          return (
            <Link
              key={item.name}
              to={item.href}
              className={cn(
                'relative flex flex-col items-center gap-0.5 px-4 py-2 min-w-[56px] min-h-[44px] justify-center transition-colors rounded-xl',
                isActive
                  ? 'text-foreground'
                  : 'text-foreground-muted hover:text-foreground'
              )}
            >
              {isActive && (
                <span className="absolute inset-0 bg-background-elevated rounded-xl" />
              )}
              <Icon className="relative w-5 h-5" />
              <span className="relative text-[10px] font-medium">{item.name}</span>
            </Link>
          );
        })}
      </div>
    </nav>
  );
}
